import React from 'react';
import { connect } from 'react-redux';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import PortfolioPageHeader from 'components/PageHeader/Portfolio';
import * as pageHeaderSelectors from 'containers/PageHeader/selectors';
import * as pageHeaderActions from 'containers/PageHeader/actions';

interface Props extends RouteComponentProps {
  weeks: number;
  onWeeksChange(value: number): void;
}

const PortfolioPageHeaderContainer: React.FC<Props> = ({ weeks, onWeeksChange }) => {
  return (
    <React.Fragment>
      <PortfolioPageHeader weeks={weeks} onWeekScopeSelect={onWeeksChange} />
    </React.Fragment>
  );
};

const mapStateToProps = state => ({
  weeks: pageHeaderSelectors.globalFilterWeeksSelector(state)
});

const mapDispatchToProps = dispatch => ({
  onWeeksChange: (value: number) => {
    dispatch(pageHeaderActions.updateGlobalFilterWeeks(value));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(PortfolioPageHeaderContainer));
